import * as React from 'react';

import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkEmptyState, UitkEmptyStateActionArea } from 'uitk-react-empty-state';
import { UitkPrimaryButton } from 'uitk-react-button';

interface ErrorEmptyStateProps {
  icon: string;
  headingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'; // UitkHeadingTag not exported from uitk-react-text
  title: string;
  body: string;
  buttonText?: string;
  clickHandler?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  altDatesErrorButtons?: JSX.Element;
}

const iconSpacingProps: UitkSpacingProps = { margin: { blockend: 'four' } };
const headingSpacingProps: UitkSpacingProps = { margin: { blockend: 'two' } };
const bodySpacingProps: UitkSpacingProps = { margin: { blockend: 'three' } };

export const ErrorEmptyState: React.FC<ErrorEmptyStateProps> = ({
  headingTag,
  icon,
  title,
  body,
  buttonText,
  clickHandler,
  altDatesErrorButtons
}: ErrorEmptyStateProps) => (
  <UitkEmptyState>
    <UitkSpacing margin={iconSpacingProps.margin}>
      <UitkIcon name={icon} size={UitkIconSize.XLARGE} />
    </UitkSpacing>
    <UitkSpacing margin={headingSpacingProps.margin}>
      <UitkHeading tag={headingTag} size={5}>
        {title}
      </UitkHeading>
    </UitkSpacing>
    <UitkSpacing margin={bodySpacingProps.margin}>
      <UitkText size={300}>{body}</UitkText>
    </UitkSpacing>
    {altDatesErrorButtons}
    {buttonText && clickHandler && (
      <UitkEmptyStateActionArea>
        <UitkPrimaryButton onClick={clickHandler}>{buttonText}</UitkPrimaryButton>
      </UitkEmptyStateActionArea>
    )}
  </UitkEmptyState>
);
